export default "__VITE_ASSET__59b49bde__"